import { render, staticRenderFns } from "./GradesList.vue?vue&type=template&id=7c5fd38f"
import script from "./GradesList.vue?vue&type=script&lang=js"
export * from "./GradesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports